import { Injectable } from '@angular/core';

import { ApiService, AuthService, AppContext, LogService, BillingService, UserService } from './../../shared';
import { Customer } from './../../shared/models/customer';
import { resolve } from 'dns';

declare const moment;

@Injectable()
export class AccountInformationService {
  oldPassword: string = '';
  newPassword: string = '';
  confirmNewPassword: string = '';

  public confirmError: string = '';
  public newPasswordErrorLength: string = '';
  public newPasswordErrorReg: string = '';
  public newPasswordError: string = '';

  showChangePassword: boolean = false;
  showCardDetails: boolean = false;
  showPlanDetails: boolean = false;
  showTrialDetails: boolean = false;

  public submitted = false;

  public showCancel = false;
  status: string = '';
  cancelSuccess: boolean = false;

  errors = {
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    update: '',
    updateErrors: '',
    oldPasswordErrors: ''
  };

  planName: string = '';
  billingPeriod: string = '';
  lastFour: string = '';
  // charge: string = '';
  trialEnd: string = '';

  passwordOkay: boolean = false;

  constructor(private api: ApiService, private auth: AuthService, public app: AppContext,
    private logger: LogService, private billing: BillingService, private user: UserService) {
  }

  getCustomer(): Promise<Customer> {
    return new Promise<Customer>((resolve, reject) => {
      this.billing.getCustomer().then((customer: Customer) => {
        if (customer.sources.length > 0) {
          this.lastFour = customer.sources[0].lastFour;
          this.showCardDetails = true;
        } else {
          this.showCardDetails = false;
        }

        if (customer.subscriptions.length > 0) {
          this.planName = customer.subscriptions[0].plan.name;
          this.billingPeriod = customer.subscriptions[0].plan.interval == 'month' ? 'Monthly' : 'Yearly';
          this.showPlanDetails = true;
  
          if (customer.subscriptions[0].status == 'trialing') {
            this.trialEnd = moment.unix(customer.subscriptions[0].trialEnd).format('YYYY-MM-DD');
            this.showTrialDetails = true;
          } else {
            this.showTrialDetails = false;
          }
        } else {
          this.showPlanDetails = false;
          this.showTrialDetails = false;
        }

        resolve(customer);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  toggleChangePassword() {
    this.showChangePassword = !this.showChangePassword;
  }

  changePassword() {
    this.submitted = true;
    this.errors.update = '';
    this.errors.updateErrors = '';
    this.errors.oldPasswordErrors = '';

    if (this.passwordOkay) {
      this.logger.log('account-information.service', 'changePassword', 'before promise');
      this.auth.changePassword(this.oldPassword, this.newPassword).then(result => {
        this.logger.log('account-information.service', 'changePassword result', result);
        this.errors.update = 'Password Changed';
        this.showChangePassword = false;
      }).catch(err => {
        this.logger.log('account-information.service', 'changePassword err', err);
        if (err = 'Error: Incorrect username or password.') {
          this.errors.oldPasswordErrors = 'Password Incorrect';
        } else {
          this.errors.updateErrors = 'something went wrong. please try again';
        }
      });
    }
  }

  validateOldPassword() {
  }

  validateNewPassword() {
    let PASSWORD_REGEXP = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^$*.\[\]{}()?-“!@#%&\/,><‘:;|_~`]).*$/;
    this.passwordOkay = true;
    this.newPasswordErrorLength = '';
    this.newPasswordErrorReg = '';
    this.newPasswordError = '';

    if (!PASSWORD_REGEXP.test(this.newPassword)) {
      this.passwordOkay = false;
      // this.newPasswordErrorReg = 'Passwords must be at least 8 characters and contain one uppercase letter,
      // one lowercase letter, one numeral, and one special character';
      this.newPasswordError = 'Invalid Password';
    }

    if (this.newPassword.length < 8) {
      this.passwordOkay = false;
      // this.newPasswordErrorLength = 'Password must be at least 8 characters';
      this.newPasswordError = 'Invalid Password';
    }

    if (this.newPassword.length > 99) {
      this.passwordOkay = false;
      // this.newPasswordErrorLength = 'Password is too long';
      this.newPasswordError = 'Invalid Password';
    }
  }

  validateConfirmPassword() {
    this.passwordOkay = true;
    this.confirmError = '';

    if (this.newPassword !== this.confirmNewPassword) {
      this.passwordOkay = false;
      this.confirmError = 'Passwords must match';
    }
  }

  toggleCancel() {
    this.showCancel = !this.showCancel;
  }

  // close() {
  //   this.showCancel = false;
  //   this.cancelSuccess = false;

  //   this.status = '';

  //   this.service.close();
  //   this.onClose.emit(true);
  // }

  cancelPlan(): Promise<any> {
    if (this.status === 'sending...') {
      return;
    }

    this.status = 'sending...';
    this.cancelSuccess = false;

    this.billing.cancel()
      .then(result => {
        this.logger.log('update-plan.service', 'cancelPlan success', result);
        this.user.getProfile();
        this.app.setAccountType('Basic');
        this.app.plan.interval = '';
        this.cancelSuccess = true;
        this.status = 'success';
      }).catch(err => {
        this.logger.log('update-plan.service', 'cancelPlan error', err);
        this.status = 'error';
        this.cancelSuccess = false;
      });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/account-information/account-information.service.ts